import { createFileRoute } from '@tanstack/react-router';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/legal/imprint')({
  head: () => ({ meta: seo({ title: 'Impresszum' }) }),
  component: ImprintRoute
});

function ImprintRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Impresszum</h1>
        <dl>
          <dt>Név</dt>
          <dd>Salai-Boldizsár Levente egyéni vállalkozó</dd>

          <dt>Székhely</dt>
          <dd>3533 Miskolc, Szeder utca 76. 2. em. 6. ajtó</dd>

          <dt>Telefon</dt>
          <dd>
            <a href="tel:+36309219561">+36 30 921 95 61</a>
          </dd>

          <dt>E-mail</dt>
          <dd>
            <a href="mailto:pixwrist@pixwrist.hu">pixwrist@pixwrist.hu</a>
          </dd>

          <dt>Web</dt>
          <dd>
            <a href="https://www.pixwrist.hu">www.pixwrist.hu</a>
          </dd>

          <dt>Nyilvántartásba vevő hatóság</dt>
          <dd>Nemzeti Adó- és Vámhivatal</dd>

          <dt>Nyilvántartási szám</dt>
          <dd>55017006</dd>

          <dt>Adószám</dt>
          <dd>56377169-1-25</dd>

          <dt>Kamara</dt>
          <dd>Borsod-Abaúj-Zemplén Megyei Kereskedelmi és Iparkamara</dd>

          <dt>Tárhelyszolgáltató</dt>
          <dd>
            Microsoft Ireland Operations Limited <br />
            One Microsoft Place <br />
            South County Business Park <br />
            Leopardstown <br />
            Dublin 18 <br />
            Ireland <br />
            <div className="mt-3">
              Tel.: +1 800 710 200 <br />
              <a href="https://azure.microsoft.com/hu-hu">
                azure.microsoft.com/hu-hu
              </a>{' '}
              <br />
              <a href="https://azure.microsoft.com/hu-hu/support/legal/subscription-agreement">
                azure.microsoft.com/hu-hu/support/legal/subscription-agreement
              </a>{' '}
              <br />
              <a href="https://www.microsoft.com/hu-hu/trust-center/privacy">
                www.microsoft.com/hu-hu/trust-center/privacy
              </a>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  );
}
